import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {AccountRole, BetStatus, ListBetsRequest, SportsBet } from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import {SportBetsService} from "../../services/SportsBetsService";
import {Form, FormListener} from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";
import {SelectInput} from "../form/SelectInput";
import {ColumnType} from "../list/list/ColumnType";


interface State extends ListViewState<ListBetsRequest> {
    listRequest? : ListBetsRequest;
    form? : ListBetsRequest;
    validationMap? : any;
    lookupExpanded?: boolean;
    blockedUsers: boolean;
}

function userLinkRenderer(prop : any , name : any, item : any) : any {
    if (item.userId) {
        return <Link key={"user-action" + item.userId} to={`/user/${item.userId}`}>{item.userId}</Link>;
    } else {
        return <div>n/a</div>;
    }
}


export class BetsListView extends ListView<State, ListBetsRequest> implements FormListener<ListBetsRequest>{

    columns = [
        { property : "id", name : "ID"},
        { property : "userId", name : "User Id", renderer: userLinkRenderer },
        { property : "betType", name : "Type", type: ColumnType.ENUM },
        { property : "provider", name : "Provider" },
        { property : "riskAccountRole", name : "Risk Role", type: ColumnType.ENUM},
        { property : "risk", name : "Risk Amount", renderer: (property: string, name: string, item: SportsBet) => {
            if(item.risk!==undefined){
                return item.risk+" "+item.currency;
            }
        }},
        { property : "integration", name : "Integration"},
        { property : "created", name : "Created", type : ColumnType.DATE},
        { property : "gradedDate", name : "Graded", type : ColumnType.DATE},
        { property : "status", name : "Status", type: ColumnType.ENUM},
        { property : "selections", name : "Selections", 
            renderer: (property: string, name: string, item: SportsBet) => {
                if(item.selections && item.selections.length > 0){
                    return item.selections.map(s => s.description).join(", ");
                }
            }
        },
        { property : "payoutAccountRole", name : "Payout Role", type: ColumnType.ENUM},
        { property : "payout", name : "Payout Amount",  renderer: (property: string, name: string, item: SportsBet) => {
            if(item.payout!==undefined){
                return item.payout+" "+item.currency;
            }
        }}
    ];

    actions = [
        { id : "betView", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/sportsbetting/bet/" + item.id }
    ];
    service : SportBetsService;

    initialState : ListBetsRequest = {
        limit: 20,
        orderBy: "id",
        id:undefined,
        startDate:undefined,
        endDate:undefined,
        ascending: false,
        userId: undefined
    }

    constructor(props : ListViewProps){
        super(props, "/sportsbetting/bets");
        this.service = getContainer().getSportBetsService();

        let locProp = this.props.location;
        if (this.state.listRequest){
            if(locProp.state && locProp.state.listRequest) {
                this.initialState.statuses = locProp.state.listRequest.statuses && locProp.state.listRequest.statuses;
                this.initialState.userId = locProp.state.listRequest.userId && locProp.state.listRequest.userId;
            }
            let lookupExpanded:boolean = false;
            if(locProp.state && locProp.state.lookupExpanded !== undefined) {
                lookupExpanded = locProp.state.lookupExpanded;
            }
            this.state = createInitialState( this.initialState, this.state = {lookupExpanded:lookupExpanded, ...this.state});
        }
    }
    onSubmit(): void {
        console.log(this.state.form);
        let listRequest : ListBetsRequest = Object.assign({},this.state.form);
        listRequest.offset = 0;
        console.log("listRequest;: ", listRequest)
        //this.updateListState(listRequest);
        setTimeout(()=> this.setState(({listRequest : listRequest, form : listRequest} as any)), 0);
    };

    onSubmitError() :  void {
        console.log("submit error!")
    }

    formDidUpdate(formModel: ListBetsRequest, validationMap?: any): void {
        if(!formModel.userId) delete formModel.userId;
        if(!formModel.id) delete formModel.id;
        
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : Event, action : string) : Promise<any> | undefined {
        return;
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.setState({listRequest:listRequest})
        }
    }
    getTitle() {
        return "List Bets"
    }

    preset(preset: "day" | "week" | "month") {

        let filter: ListBetsRequest|undefined = this.state.listRequest;
        let today = new Date(new Date().setDate(new Date().getDate())).toISOString().slice(0,10);
        let yesterday = new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0,10);
        let sevenDaysAgo = new Date(new Date().setDate(new Date().getDate()-7)).toISOString().slice(0,10);
        let thirtyDaysAgo = new Date(new Date().setDate(new Date().getDate()-30)).toISOString().slice(0,10);

        switch(preset) {
            case "day":
                filter = {...this.state.form, startDate: yesterday as any, endDate: today as any};
                break;

            case "week":
                filter = {...this.state.form, startDate: sevenDaysAgo as any, endDate: today as any};
                break;

            case "month":
                filter = {...this.state.form, startDate: thirtyDaysAgo as any, endDate: today as any};
                break;
        }


        // this.updateListState({...filter});
        this.setState({form:filter})
    }

    getSearchByUserId() {
        return(
            <div className="row">
                <div className={"col-lg-6"}>
                    <div className="card-box">
                        <h4>Find By User Id</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="userId">
                                <FormInput model={"userId"} className={"form-control"} validators={[Validators.number()]}/>
                                <span className={"help-text"}>Finds logs by user id. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
                <div className={"col-lg-6"}>
                    <div className="card-box">
                        <h4>Find By Id</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="id">
                                <FormInput model={"id"} className={"form-control"} validators={[Validators.number()]}/>
                                <span className={"help-text"}>Finds bet by id. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
            </div>
        )
    }

    getSearchByFilter() {

        return(
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !this.state.lookupExpanded ? this.setState({lookupExpanded:true}) : null}>
                {this.state.lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); this.setState({lookupExpanded : false});}}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); this.setState({lookupExpanded : true});}}><i className="mdi mdi-plus"></i></a>
                )}

                <h4 className="header-title mb-3" onClick={()=>this.setState({lookupExpanded : !this.state.lookupExpanded})}>Advanced Search</h4>
                {this.state.lookupExpanded && (
                    <div>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>Created</label>
                                        <h5>Presets</h5>
                                        <div>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("day")}>Day</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("week")}>Week</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("month")}>Month</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className={"form-group"}>
                                        <label htmlFor={"startDate"}>From:</label>
                                        <FormInput model={"startDate"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <label htmlFor={"endDate"}>To:</label>
                                        <FormInput model={"endDate"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <span className={"help-text"}>To but not included</span>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>Bet Status</label>
                                        <SelectInput className="form-control  col-lg-4" model="statuses" size={[...Object.keys(BetStatus)].length} multiple={true}
                                                     values={[...Object.keys(BetStatus)]}
                                                     optional={true}
                                                     onFocus={() => this.clearForAdvanced()}>
                                        </SelectInput>
                                        <span className={"help-text"}>Search for bet based on their Status. CTRL select for multiple statuses.</span>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>Risk Account Role</label>
                                        <SelectInput className="form-control  col-lg-4" model="riskAccountRoles" size={[...Object.keys(AccountRole)].length} multiple={true}
                                                     values={[...Object.keys(AccountRole)]}
                                                     optional={true}
                                                     onFocus={() => this.clearForAdvanced()}>
                                        </SelectInput>
                                        <span className={"help-text"}>Search for bet based on their account roles. CTRL select for multiple account roles.</span>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="form-group">
                                    <Submit className={"btn btn-primary"}>Search</Submit>
                                    <button onClick={() => this.clearFilter()} className={"btn btn-secondary"}>Clear</button>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        )
    }

    clearForAdvanced() {
        this.setState({form: {...this.state.form}})

    }

    clearFilter() {
        this.setState({form: this.initialState})
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                {this.getSearchByUserId()}
                {this.getSearchByFilter()}
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }



}

export default withRouter(BetsListView)